<template>
  <b-card-code title="Hasil Kaji Etik">

    <b-tabs v-model="tabIndex">
      <b-tab title="Penilaian" v-if="mainData.is_penguji == true">
        <b-alert show variant="danger" class="text-center" style="height: auto; padding:15px;"
          v-if="mainData && mainData.catatan_perubahan_nilai.catatan != null">{{mainData.catatan_perubahan_nilai.catatan}}</b-alert>
        <form-wizard color="#7367F0" :title="null" :subtitle="null" shape="square" :finish-button-text="'Simpan'"
          back-button-text="Kembali" next-button-text="Lanjut" class="mb-3"
          @on-complete="simpanDataJawaban('konfirmasi')">
          <tab-content v-for="item in mainData.pertanyaan" :key="convertToKey(item.group)"
            :title="formattedTitle(item.group)">
            <!-- :before-change="() => validationForm(convertToKey(item.group))" -->
            <validation-observer :ref="`reviewRules${convertToKey(item.group)}`" tag="form">
              <!-- Other content within the observer -->
              <b-row class="pertanyaan" v-for="pertanyaan in item.pertanyaan" :key="pertanyaan.id">
                <b-col cols="6">
                  <validation-provider v-if="pertanyaan.is_header === null" v-slot="{ errors }"
                    :name="`form${pertanyaan.id}`" :rules="validationRules(pertanyaan.id)">
                    <b-form-group :label="pertanyaan.pertanyaan" :label-for="`form${pertanyaan.id}`">
                      <b-form-radio-group :id="`form${pertanyaan.id}`" v-model="pertanyaan.jawaban"
                        :disabled="pertanyaan.is_locked == 1 && mainData.is_pembimbing == false">
                        <b-form-radio value="2">Layak/Baik/Jelas</b-form-radio>
                        <b-form-radio value="1">Tidak/Kurang</b-form-radio>
                        <b-form-radio value="0">Tidak relevan</b-form-radio>
                      </b-form-radio-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                  <label v-else>{{ pertanyaan.pertanyaan }}</label>
                </b-col>
              </b-row>
            </validation-observer>
          </tab-content>
        </form-wizard>

        <!-- <b-col cols="12">
            <div class="d-flex justify-content-end">
              <b-button
              v-if=" mainData.status_pengajuan_sidang_id != 5"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-1 mr-1"
              @click="simpanDataJawaban('konfirmasi')"
            >
              Simpan
            </b-button>
            </div>
          </b-col> -->
      </b-tab>
      <b-tab title="Hasil Pengkajian" v-if="mainData.is_penguji == true">
        <div class="mt-5 mb-5">
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Layak (tidak ada perbaikan, atau ada perbaikan minor tapi pengaju tidak perlu submit dan review ulang)"
                label-for="judul">
                <b-form-textarea id="judul" rows="3"
                  placeholder="Isi Catatan Jika Layak (tidak ada perbaikan, atau ada perbaikan minor tapi pengaju tidak perlu submit dan review ulang)"
                  v-model="catatan.judul" />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Perlu diperbaiki dan direview ulang oleh tim kaji etik" label-for="abstrak">
                <b-form-textarea id="abstrak" rows="3"
                  placeholder="Isi Catatan Jika Perlu diperbaiki dan direview ulang oleh tim kaji etik"
                  v-model="catatan.abstrak" />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group label="Diajukan untuk rapat fullboard" label-for="Kepustakaan">
                <b-form-textarea id="Kepustakaan" rows="3" placeholder="Diajukan untuk rapat fullboard"
                  v-model="catatan.kepustakaan" />
              </b-form-group>
            </b-col>
            <!-- <b-col cols="12">
                <b-form-group
                  label="Lainnya"
                  label-for="Lainnya"
                >
                  <b-form-textarea
                    id="Lainnya"
                    rows="3"
                    placeholder="Lainnya"
                    v-model="catatan.lainnya"
                  />
                </b-form-group>
              </b-col> -->
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="d-flex justify-content-end">
                <b-button v-if="mainData.status_pengajuan_sidang_id != 5" v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary" class="mt-1 mr-1" @click="simpanDataCatatan">
                  Simpan
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-tab>
      <b-tab title="Nilai Akhir" v-if="$can('all','management') || $can('cetak', 'hasil-kajietik')">
        <b-card class="border mb-0">
          <div>
            <!-- <h5 class="mb-3">Nilai Akhir Mahasiswa</h5> -->
            <b-row>
              <b-col cols="6">
                <h5 class="mb-3 mr-3">Nama</h5>
              </b-col>
              <b-col cols="6">
                <h5>{{mainData.nama_mahasiswa}}</h5>
              </b-col>
            </b-row>
            <!-- <b-row>
                <b-col cols="6">
                    <h5 class="mb-3 mr-3">NPM</h5>
                </b-col>
                <b-col cols="6">
                    <h5>{{mainData.npm}}</h5>
                </b-col>
              </b-row> -->
            <b-row>
              <b-col cols="6">
                <h5 class="mb-3 mr-3">Judul Penelitian</h5>
              </b-col>
              <b-col cols="6">
                <h5>{{mainData.judul}}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <h5 class="mb-3 mr-3">Keterangan Lulus/Tidak</h5>
              </b-col>
              <b-col cols="6">
                <v-select id="status_hasil_sidang" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :reduce="val => val.value" :options="statusHasilSidangOption.options"
                  v-model="mainData.status_hasil_sidang_id" placeholder="Pilih Status Hasil Review" />
              </b-col>
            </b-row>
            <b-row v-if="mainData.status_hasil_sidang_id == 'bb9947512ad89679db5736f951c8359e'">
              <b-col cols="6">
                <h5 class="mb-3 mr-3">Tanggal Awal Revisi</h5>
              </b-col>
              <b-col cols="6">
                <b-form-datepicker id="awal-datepicker" v-model="mainData.tanggal_awal_revisi" class="mb-2"
                  locale="ID"></b-form-datepicker>
              </b-col>
            </b-row>
            <b-row v-if="mainData.status_hasil_sidang_id == 'bb9947512ad89679db5736f951c8359e'">
              <b-col cols="6">
                <h5 class="mb-3 mr-3">Tanggal Akhir Revisi</h5>
              </b-col>
              <b-col cols="6">
                <b-form-datepicker id="akhir-datepicker" v-model="mainData.tanggal_akhir_revisi" class="mb-2"
                  locale="ID"></b-form-datepicker>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="d-flex justify-content-end">
                  <!-- <b-button v-if="mainData.is_pembimbing == true && mainData.status_pengajuan_sidang_id != 5"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="warning" class="mr-1"
                    @click="permintaanPerubahanNilai('konfirmasi')">
                    Permintaan Perubahan Nilai
                  </b-button> -->
                  <b-button v-if="mainData.status_pengajuan_sidang_id != 5" v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary" class="mr-1" @click="simpanStatusHasilSidang('konfirmasi')">
                    Simpan
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-card>
        <!-- <b-card class="border mb-0">
            <div v-for="item in mainData.dospem" :key="item.id">
              <h5 class="mb-3">{{item.nama_dosen}} (Dosen Pembimbing)</h5>
              <b-row v-for="pertanyaan in item.pertanyaan" :key="pertanyaan.id">
                <b-col cols="6">
                    <h5 class="mb-3 mr-3">{{pertanyaan.group}}</h5>
                </b-col>
                <b-col cols="6">
                    <h5>Nilai Rata-Rata : {{pertanyaan.nilai_rata_rata}}</h5>
                </b-col>
              </b-row>
              <h5 class="mb-3">Nilai Akhir : {{item.nilai_akhir}}</h5>
            </div>
          </b-card> -->
        <b-card class="border mb-0 mt-2">
          <div class="mb-3" v-for="item in mainData.dospeng" :key="item.id">
            <h5 class="mb-3">{{item.nama_dosen}} (Reviewer)</h5>
            <!-- <b-row v-for="pertanyaan in item.pertanyaan" :key="pertanyaan.id">
                <b-col cols="6">
                    <h5 class="mb-3 mr-3">{{pertanyaan.group}}</h5>
                </b-col>
                <b-col cols="6">
                    <h5>Nilai Rata-Rata : {{pertanyaan.nilai_rata_rata}}</h5>
                </b-col> 
              </b-row> -->
            <!-- <h5 class="mb-3">Nilai Akhir : {{item.nilai_akhir}}</h5> -->

            <b-button v-b-modal="'modal-center-' + item.id" variant="info">Lihat Kriteria Penilaian</b-button>
            <b-modal :id="'modal-center-' + item.id" centered title="Data Kriteria Penilaian" size="xl"
              :hide-footer="true">
              <b-tabs>
                <b-tab v-for="itemPertanyaan in item.pertanyaan" :key="itemPertanyaan.id"
                  :title="formattedTitle(itemPertanyaan.group)">

                  <div class="d-flex">
                    <h5 class="mb-3 mr-3">{{ itemPertanyaan.group }}</h5>
                    <!-- <h5>Nilai Rata-Rata : {{item.nilai_rata_rata}}</h5> -->
                  </div>
                  <b-row v-for="pertanyaan in itemPertanyaan.pertanyaan" :key="pertanyaan.id">
                    <b-col cols="12">
                      <b-form-group :label="pertanyaan.pertanyaan" :label-for="pertanyaan.pertanyaan"
                        v-if="pertanyaan.is_header === null">
                        <b-form-radio-group v-model="pertanyaan.jawaban" :disabled="true">
                          <b-form-radio value="2">Layak/Baik/Jelas</b-form-radio>
                          <b-form-radio value="1">Tidak/Kurang</b-form-radio>
                          <b-form-radio value="0">Tidak relevan</b-form-radio>
                        </b-form-radio-group>
                      </b-form-group>
                      <label v-else>
                        {{ pertanyaan.pertanyaan }}
                      </label>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-modal>

            <hr>
          </div>
        </b-card>
      </b-tab>
      <b-tab title="Hasil Pengkajian" v-if="mainData.is_penguji == false">
        <div class="mt-5 mb-5">
          <form-wizard-catatan :catatan_rev="mainData.catatan_revisi" />
        </div>
      </b-tab>
      <!-- Jika Lulus dengan revisi -->
      <b-tab
        :title="mainData.status_hasil_sidang_id == 'bb9947512ad89679db5736f951c8359e' ? 'Berkas Revisi' : 'Berkas Kelengkapan'">
        <form-wizard-number-revisi :pengajuan_sidang_uuid="mainData.pengajuan_sidang_uuid" />
        <!-- <div class="mt-5 mb-5">
          <b-card class="border mb-0">
            <b-row>
              <b-col md="6" v-if="mainData.status_hasil_sidang_id == 'bb9947512ad89679db5736f951c8359e'">
              <b-form-group
                label="File Revisi Dokumen Pengambilan Data"
                label-for="file revisi Dokumen Pengambilan Data"
              >
                <validation-provider
                  #default="{ errors }"
                  name="file revisi Dokumen Pengambilan Data"
                >
                <div class="d-flex">
                   <b-form-file
                    ref="file-input"
                    v-model="file.file_revisi_ta"
                    accept="application/pdf"
                  />
                  <b-button
                    v-if="mainData.view_file_revisi_ta != null"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="mb-75 mr-75 ml-1"
                    @click="lihatFile(mainData.view_file_revisi_ta)"
                  >
                    Lihat
                  </b-button>
                </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="6">
              <b-form-group
                label="File Informed Consent"
                label-for="file Informed Consent"
              >
                <validation-provider
                  #default="{ errors }"
                  name="file Informed Consent"
                >
                <div class="d-flex">
                   <b-form-file
                    ref="file-input"
                    v-model="file.file_naskah_ringkas"
                    accept="application/pdf"
                  />
                  <b-button
                    v-if="mainData.view_file_naskah_ringkas != null"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="mb-75 mr-75 ml-1"
                    @click="lihatFile(mainData.view_file_naskah_ringkas)"
                  >
                    Lihat
                  </b-button>
                </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="6">
              <b-form-group
                label="File Revisi prosedur deception, prosedur invasif, dll"
                label-for="file Deskripsi prosedur deception, prosedur invasif, dll"
              >
                <validation-provider
                  #default="{ errors }"
                  name="file Revisi prosedur deception, prosedur invasif, dll"
                >
                <div class="d-flex">
                   <b-form-file
                    ref="file-input"
                    v-model="file.file_deskripsi_hasil_penelitian"
                    accept="application/pdf"
                  />
                  <b-button
                    v-if="mainData.view_file_deskripsi_hasil_penelitian != null"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="mb-75 mr-75 ml-1"
                    @click="lihatFile(mainData.view_file_deskripsi_hasil_penelitian)"
                  >
                    Lihat
                  </b-button>
                </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="6">
              <b-form-group
                label="File Revisi debriefing"
                label-for="file Revisi debriefing"
              >
                <validation-provider
                  #default="{ errors }"
                  name="file Revisi debriefing"
                >
                <div class="d-flex">
                   <b-form-file
                    ref="file-input"
                    v-model="file.file_lembar_pengesahan"
                    accept="application/pdf"
                  />
                  <b-button
                    v-if="mainData.view_file_lembar_pengesahan != null"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="mb-75 mr-75 ml-1"
                    @click="lihatFile(mainData.view_file_lembar_pengesahan)"
                  >
                    Lihat
                  </b-button>
                </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            </b-row>
             
          </b-card>
        </div> -->
      </b-tab>
    </b-tabs>

    <b-row>
      <b-col cols="12">
        <div class="d-flex justify-content-end">
          <b-button v-if="(mainData.nomor_surat != null) && mainData.status_pengajuan_sidang_id == 5"
            variant="outline-primary" class="mt-1 ml-1" title="Download" @click="downloadSuratLolos()">
            Surat Keterangan Lolos Kaji Etik
          </b-button>
          <b-button v-if="$can('all', 'management') && mainData.status_pengajuan_sidang_id != 5"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mt-1 ml-1"
            @click="simpanBerkas('konfirmasi')">
            Simpan
          </b-button>
          <b-button
            v-if="($can('all', 'management')) && (mainData.nomor_surat == null) && mainData.status_pengajuan_sidang_id == 5"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mt-1 ml-1"
            @click="$bvModal.show('bv-modal-tandai-selesai')">
            Tandai Selesai
          </b-button>
        </div>
      </b-col>
    </b-row>
    <div>
      <b-modal id="bv-modal-tandai-selesai" hide-footer>
        <template #modal-title>
          Konfirmasi
        </template>
        <div class="d-block text-center mt-3">
          <h3>Apakah anda yakin ingin menandai selesai?</h3>
        </div>
        <b-form-group label="Nomor Surat:">
          <b-form-input v-model="mainData.nomor_surat" placeholder="Masukkan Nomor Surat"></b-form-input>
        </b-form-group>
        <div class="d-flex justify-content-center mt-3">
          <b-button class="mr-1" style="width: 90px;" variant="success"
            @click="tandaiSelesai('ya')">Simpan</b-button>
          <b-button variant="danger" @click="$bvModal.hide('bv-modal-tandai-selesai')">Tidak</b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal id="bv-modal-konfirmasi" hide-footer>
        <template #modal-title>
          Konfirmasi
        </template>
        <div class="d-block text-center mt-3">
          <h3>Apakah anda yakin ingin memperoses penilaian ini?</h3>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <b-button class="mr-1" style="width: 90px;" variant="success" @click="simpanDataJawaban('ya')">Ya</b-button>
          <b-button variant="danger" @click="$bvModal.hide('bv-modal-konfirmasi')">Tidak</b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal id="bv-modal-konfirmasi-nilai-akhir" hide-footer>
        <template #modal-title>
          Konfirmasi
        </template>
        <div class="d-block text-center mt-3">
          <h3>Apakah anda yakin ingin memperoses penilaian ini?</h3>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <b-button class="mr-1" style="width: 90px;" variant="success"
            @click="simpanStatusHasilSidang('ya')">Ya</b-button>
          <b-button variant="danger" @click="$bvModal.hide('bv-modal-konfirmasi-nilai-akhir')">Tidak</b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal id="bv-modal-konfirmasi-berkas" hide-footer>
        <template #modal-title>
          Konfirmasi
        </template>
        <div class="d-block text-center mt-3">
          <h3>Apakah anda yakin ingin memperoses berkas ini?</h3>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <b-button class="mr-1" style="width: 90px;" variant="success" @click="simpanBerkas('ya')">Ya</b-button>
          <b-button variant="danger" @click="$bvModal.hide('bv-modal-konfirmasi-berkas')">Tidak</b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal id="bv-modal-konfirmasi-perubahan-nilai" hide-footer>
        <template #modal-title>
          Konfirmasi
        </template>
        <div class="d-block mt-3">
          <h3 class="mb-3 text-center">Apakah anda yakin ingin mengirim permintaan perubahan nilai ini?</h3>
          <b-form-group :label="'Catatan perubahan nilai'" :label-for="'Catatan perubahan nilai'">
            <b-form-textarea id="catatan_perubahan_nilai" placeholder="Catatan Perubahan Nilai"
              v-model="perubahan_nilai.catatan" rows="3" />
          </b-form-group>
          <b-form-group :label="'Dosen Penguji'" :label-for="'Dosen Penguji'">
            <v-select id="dosen" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :reduce="val => val.value"
              :options="dosenPengujiOption.options" v-model="perubahan_nilai.dosen_penguji_id"
              placeholder="Pilih Dosen Penguji" />
          </b-form-group>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <b-button class="mr-1" style="width: 90px;" variant="success"
            @click="permintaanPerubahanNilai('ya')">Ya</b-button>
          <b-button variant="danger" @click="$bvModal.hide('bv-modal-konfirmasi-perubahan-nilai')">Tidak</b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal id="bv-modal-konfirmasi-selesai" hide-footer>
        <template #modal-title>
          Konfirmasi
        </template>
        <div class="d-block mt-3">
          <h3 class="mb-3 text-center">Apakah anda yakin ingin tandai selesai Hasil Review ini?</h3>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <b-button class="mr-1" style="width: 90px;" variant="success" @click="tandaiSelesai('ya')">Ya</b-button>
          <b-button variant="danger" @click="$bvModal.hide('bv-modal-konfirmasi-selesai')">Tidak</b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal id="modal-center-loading" centered title="Loading" hide-footer no-close-on-backdrop no-close-on-esc
        hide-header-close v-if="showModal === 1">
        <div class="d-flex justify-content-center mt-2">
          <b-spinner :variant="'dark'"></b-spinner>
        </div>
        <div class="d-flex justify-content-center mt-2">
          Loading....
        </div>
        <b-button class="mt-3" block @click="reload()" variant="primary">Muat Ulang</b-button>
      </b-modal>
    </div>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { FormWizard, TabContent } from 'vue-form-wizard'
import FormWizardNumberRevisi from '@/views/pages/pengajuan-kajietik/FormWizardNumberRevisi.vue'
import {
  BButtonGroup, BButton, BCard, BFormRadioGroup, BFormRadio, BTab, BTabs, BCardText, BFormTextarea, BRow, BCol, BFormGroup, BFormInput, BFormDatepicker, BFormFile, BAlert, BModal, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  getDetailHasilSidang,
  updateCatatanHasilSidang,
  updateJawabanPenilaianHasilSidang,
  getStatusHasilSidang,
  updateStatusHasilSidang,
  updateBerkasHasilSidang,
  uploadFileBerkasHasilSidang,
  downloadBerkasHasilSidang,
  postPermintaanPerubahanNilai,
  postTandaiSelesai,
  downloadSuratLolos,
  getPengajuanSidangDetail,
} from '@/connection-api/master'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import FormWizardCatatan from '@/views/pages/hasil-kajietik/catatan-revisi/FormWizardCatatan.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import { required } from '@validations'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
export default {
  components: {
    BCardCode,
    BFormRadioGroup,
    BFormRadio,
    BButtonGroup,
    BButton,
    BCard,
    BTab,
    BTabs,
    BCardText,
    BFormTextarea,
    BRow,
    BCol,
    BFormGroup,
    FormWizard,
    FormWizardCatatan,
    BFormInput,
    vSelect,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BAlert,
    BModal,
    BSpinner,
    TabContent,
    FormWizardNumberRevisi,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      showModal: 1,
      perubahan_nilai: {},
      file: {},
      tabIndex: 0,
      mainData: {},
      catatan: {},
      jawaban_penilaian: {},
      status_hasil_sidang: {},
      selesai: {},
      berkas: {},
      // codeProgrammatically,
      statusHasilSidangOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Status Hasil Review --' },
        ],
      },
      dosenPengujiOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Dosen Penguji --' },
        ],
      },
    }
  },
  methods: {
    convertToKey(inputString) {
      // Remove special characters, spaces, and convert to lowercase
      return inputString
        .replace(/[^\w\s]/g, '') // Remove special characters
        .trim() // Trim whitespace from the edges
        .toLowerCase() // Convert to lowercase
        .replace(/\s+/g, '_'); // Replace spaces with underscores
    },
    validationRules(fieldId) {
      // Implement your dynamic validation rules here based on fieldId
      // For example, if you need different rules for different fields
      // return appropriate rules based on the fieldId
      if (fieldId === 'specific_field_id') {
        return 'required|min:3|max:10'; // Example rules
      }
      return 'required'; // Default rule
    },
    validationForm(groupid) {
      return new Promise((resolve, reject) => {
        if (this.$refs[`reviewRules${groupid}`]) {
          // console.log(`reviewRules${groupid}`);
          // this.$refs[`reviewRules${groupid}`].validate().then(success => {
          //   if (success) {
          //     resolve(); // Resolve the promise if validation is successful
          //   } else {
          //     reject('Validation failed'); // Reject with an error message if validation fails
          //   }
          // }).catch(error => {
          //   reject(error); // Catch any unexpected errors during validation
          // });
        } else {
          reject('Ref not found'); // Reject if the specified ref is not found
        }
      });
    },
    formattedTitle(title) {
      const formatted = title.toUpperCase();

      // Remove the word "aspek"
      const removedAspek = formatted.replace('ASPEK', '');
      const beforeParentheses = removedAspek.split('(')[0].trim();
      return beforeParentheses;
    },
    async downloadSuratLolos() {
      const result = await downloadSuratLolos(this.mainData.pengajuan_sidang_id)
      const url = window.URL.createObjectURL(new Blob([result.data]))
      const link = document.createElement('a')
      const date = new Date().toLocaleString(['ban', 'id'])
      link.href = url
      link.setAttribute('download', this.mainData.id + 'Surat-Keterangan-Lolos-Kaji-Etik.pdf')
      document.body.appendChild(link)
      link.click()
    },
    completeCheck(success_check)
    {
      if(success_check.length == 2)
      {
        this.showModal = 0
      }
    },
    reload()
    {
      window.location.reload()
    },
    simpanBerkas(params) {
      var marking = null;
      if(params == 'konfirmasi')
      {
        this.$bvModal.show('bv-modal-konfirmasi-berkas')
      } else if (params == 'ya'){
        if(this.file.file_revisi_ta != null)
        {
          uploadFileBerkasHasilSidang(this.file.file_revisi_ta, 'user', event => {
          this.progress = Math.round((100 * event.loaded) / event.total)
        })
          .then(response1 => {
            this.mainData.file_revisi_ta = response1.data.data;

            updateBerkasHasilSidang(this.mainData)
            .then(response => {
              if (response.data.success == true) {
                marking = 1;
                if(response.data.judul == 'file_revisi_ta')
                {
                   this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Hasil Review',
                      icon: 'EditIcon',
                      variant: 'success',
                      text: 'Data berhasil disimpan.',
                    },
                  })
                } 
              } else {
                if(response.data.judul == 'file_revisi_ta')
                {
                   this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Hasil Review',
                      icon: 'EditIcon',
                      variant: 'danger',
                      text: response.data.message,
                    },
                  })
                } 
              }
            })
            .catch(error => {
              success_check.push(error)
              this.completeCheck(success_check)
            });
          })
        .catch(error => {
          success_check.push(error)
          this.completeCheck(success_check)
        });
        }
        
        if(this.file.file_naskah_ringkas != null)
        {
          uploadFileBerkasHasilSidang(this.file.file_naskah_ringkas, 'user', event => {
          this.progress = Math.round((100 * event.loaded) / event.total)
        })
          .then(response2 => {
            this.mainData.file_naskah_ringkas = response2.data.data;

            updateBerkasHasilSidang(this.mainData)
            .then(response => {
              if (response.data.success == true) {
                marking = 1;
                if(response.data.judul == 'file_naskah_ringkas')
                {
                   this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Hasil Review',
                      icon: 'EditIcon',
                      variant: 'success',
                      text: 'Data berhasil disimpan.',
                    },
                  })
                } 
              } else {
                if(response.data.judul == 'file_naskah_ringkas')
                {
                   this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Hasil Review',
                      icon: 'EditIcon',
                      variant: 'danger',
                      text: response.data.message,
                    },
                  })
                } 
              }
            })
            .catch(error => {
              success_check.push(error)
              this.completeCheck(success_check)
            });
          })
        .catch(error => {
          success_check.push(error)
          this.completeCheck(success_check)
        });
        }
        
        if(this.file.file_deskripsi_hasil_penelitian)
        {
          uploadFileBerkasHasilSidang(this.file.file_deskripsi_hasil_penelitian, 'user', event => {
          this.progress = Math.round((100 * event.loaded) / event.total)
        })
          .then(response3 => {
            this.mainData.file_deskripsi_hasil_penelitian = response3.data.data;

            updateBerkasHasilSidang(this.mainData)
            .then(response => {
              if (response.data.success == true) {
                marking = 1;
                if(response.data.judul == 'file_deskripsi_hasil_penelitian')
                {
                   this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Hasil Review',
                      icon: 'EditIcon',
                      variant: 'success',
                      text: 'Data berhasil disimpan.',
                    },
                  })
                } 
              } else {
                 if(response.data.judul == 'file_deskripsi_hasil_penelitian')
                  {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Hasil Review',
                        icon: 'EditIcon',
                        variant: 'danger',
                        text: response.data.message,
                      },
                    })
                  } 
              }
            })
            .catch(error => {
              success_check.push(error)
              this.completeCheck(success_check)
            });
          })
        .catch(error => {
          success_check.push(error)
          this.completeCheck(success_check)
        });
        }

        if(this.file.file_lembar_pengesahan)
        {
          uploadFileBerkasHasilSidang(this.file.file_lembar_pengesahan, 'user', event => {
          this.progress = Math.round((100 * event.loaded) / event.total)
        })
          .then(response4 => {
            this.mainData.file_lembar_pengesahan = response4.data.data;

            updateBerkasHasilSidang(this.mainData)
            .then(response => {
              if (response.data.success == true) {
                marking = 1;
               if(response.data.judul == 'file_lembar_pengesahan')
                {
                   this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Hasil Review',
                      icon: 'EditIcon',
                      variant: 'success',
                      text: 'Data berhasil disimpan.',
                    },
                  })
                } 
              } else {
                 if(response.data.judul == 'file_lembar_pengesahan')
                  {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Hasil Review',
                        icon: 'EditIcon',
                        variant: 'danger',
                        text: response.data.message,
                      },
                    })
                  } 
              }
            })
            .catch(error => {
              success_check.push(error)
              this.completeCheck(success_check)
            });
          })
        .catch(error => {
          success_check.push(error)
          this.completeCheck(success_check)
        });
        }

        if(this.file.file_pas_foto)
        {
          uploadFileBerkasHasilSidang(this.file.file_pas_foto, 'user', event => {
          this.progress = Math.round((100 * event.loaded) / event.total)
        })
          .then(response5 => {
            this.mainData.file_pas_foto = response5.data.data;

            updateBerkasHasilSidang(this.mainData)
            .then(response => {
              if (response.data.success == true) {
                marking = 1;
                 if(response.data.judul == 'file_pas_foto')
                  {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Hasil Review',
                        icon: 'EditIcon',
                        variant: 'success',
                        text: 'Data berhasil disimpan.',
                      },
                    })
                  } 
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Hasil Review',
                    icon: 'EditIcon',
                    variant: 'danger',
                    text: response.data.message,
                  },
                })
              }
            })
            .catch(error => {
              success_check.push(error)
              this.completeCheck(success_check)
            });
          })
        .catch(error => {
          success_check.push(error)
          this.completeCheck(success_check)
        });
        }
        this.$bvModal.hide('bv-modal-konfirmasi-berkas')
          setTimeout(() => {
            location.reload()
          }, 20000);
      }
    },
    async lihatFile(file) {
      try {
        if (typeof file === 'object') {
          // kode yang dijalankan jika file adalah object
          file = file.nama
        }
        const resp = await downloadBerkasHasilSidang(file);
        var type_file = file.substring(file.length - 4);
        if (type_file === ".pdf") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "application/pdf" })
          );
        }
        if (type_file === ".png" || type_file === ".PNG" || 
            type_file === ".jpg" || type_file === ".JPG" || 
            type_file === ".jpeg" || type_file === ".JPEG") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "image/" + type_file.slice(1) })
          );
        }
        window.open(this.imageFile);
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hasil Review',
            icon: 'EditIcon',
            variant: 'danger',
            text: 'File tidak ditemukan',
          },
          duration: 5000,
        })
      }
    },
    permintaanPerubahanNilai(params)
   {
    if(params == 'konfirmasi')
    {
      this.$bvModal.show('bv-modal-konfirmasi-perubahan-nilai')
    } else if(params == 'ya') {
      this.perubahan_nilai.hasil_sidang_id = this.$route.params.uuid
      postPermintaanPerubahanNilai(this.perubahan_nilai)
      .then(response => {
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Hasil Review',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil disimpan',
            },
          })
          this.$bvModal.hide('bv-modal-konfirmasi-perubahan-nilai')
        } else {
          this.$bvModal.hide('bv-modal-konfirmasi-perubahan-nilai')
           this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Hasil Review',
              icon: 'EditIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
        }
      })
      .catch(error => console.log(error));
    }
   },
   tandaiSelesai(params)
   {
    if(params == 'konfirmasi')
    {
      this.$bvModal.show('bv-modal-konfirmasi-selesai')
    } else if(params == 'ya') {
      this.selesai.hasil_sidang_id = this.$route.params.uuid
      this.selesai.nomor_surat = this.mainData.nomor_surat;

      postTandaiSelesai(this.selesai)
      .then(response => {
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Hasil Review',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil disimpan',
            },
          })
          this.$bvModal.hide('bv-modal-konfirmasi-selesai')
          this.$router.push({name: 'hasil-kajietik'})
        } else {
          this.$bvModal.hide('bv-modal-konfirmasi-selesai')
           this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Hasil Review',
              icon: 'EditIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
        }
      })
      .catch(error => console.log(error));
    }
   },
   simpanStatusHasilSidang(params)
   {
    if(params == 'konfirmasi')
    {
      this.$bvModal.show('bv-modal-konfirmasi-nilai-akhir')
    } else if(params == 'ya') {
    this.status_hasil_sidang.uuid = this.$route.params.uuid
    this.status_hasil_sidang.status_hasil_sidang_id = this.mainData.status_hasil_sidang_id
    this.status_hasil_sidang.tanggal_awal_revisi = this.mainData.tanggal_awal_revisi
    this.status_hasil_sidang.tanggal_akhir_revisi = this.mainData.tanggal_akhir_revisi
    updateStatusHasilSidang(this.status_hasil_sidang)
      .then(response => {
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Hasil Review',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil disimpan',
            },
          })
          this.$bvModal.hide('bv-modal-konfirmasi-nilai-akhir')
        } else {
           this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Hasil Review',
              icon: 'EditIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
        }
      })
      .catch(error => console.log(error));
    }
   },
   simpanDataCatatan()
   {
    this.catatan.uuid = this.$route.params.uuid
    updateCatatanHasilSidang(this.catatan)
      .then(response => {
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Hasil Review',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil disimpan',
            },
          })
        } else {
           this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Hasil Review',
              icon: 'EditIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
        }
      })
      .catch(error => console.log(error));
   },
   simpanDataJawaban(params)
   {
    if(params == 'konfirmasi')
    {
      this.$bvModal.show('bv-modal-konfirmasi')
    } else if(params == 'ya') {
      this.jawaban_penilaian = this.mainData
    updateJawabanPenilaianHasilSidang(this.jawaban_penilaian)
      .then(response => {
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Hasil Review',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil disimpan',
            },
          })
          this.$bvModal.hide('bv-modal-konfirmasi')
          setTimeout(() => {
            location.reload()
          }, 2000);
        } else {
           this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Hasil Review',
              icon: 'EditIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
        }
      })
      .catch(error => console.log(error));
    }
   },
   DetailHasilSidang()
   {
    getDetailHasilSidang(this.$route.params.uuid)
      .then(response => {
        if (response.data.success === true) {
          return response.data.data
        }
      })
      .catch(error => console.log(error));
   }
  },
  async mounted() {
    this.$bvModal.show('modal-center-loading')
    var success_check = []
    await getDetailHasilSidang(this.$route.params.uuid)
      .then(response => {
        if (response.data.success === true) {
          success_check.push('success')
          this.completeCheck(success_check)
          this.mainData = response.data.data
        //  console.log('Response', this.mainData);
         
          if (response.data.data.dosen_penguji.length > 0) {
            response.data.data.dosen_penguji.forEach(element => {
              this.dosenPengujiOption.options.push({
                label: element.nama,
                value: element.uuid,
              })
            })
          }
          if(response.data.data.catatan)
          {
            this.catatan = response.data.data.catatan
          }
        }
      })
      .catch(error => console.log(error));

    await getStatusHasilSidang()
    .then(response => {
    if (response.data.length > 0) {
      success_check.push('success')
      this.completeCheck(success_check)
      response.data.forEach(element => {
        this.statusHasilSidangOption.options.push({
          label: element.nama,
          value: element.uuid,
        })
      })
    }
    })
    .catch(error => console.log(error));

  },
}
</script>
<style>
.custom-checkbox .custom-control-label, .custom-radio .custom-control-label {
    color: #5e5873;
    font-size: 0.857rem;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
.vue-form-wizard .wizard-navigation .wizard-nav li a .stepTitle {
  font-size: 0.8rem!important;
}
</style>
